module.exports = __webpack_public_path__ + "img/1602348976.f8de3633.png";